module.exports = __webpack_public_path__ + "img/small_cup.8015b8c9.svg";